import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import ApartmentIcon from '@mui/icons-material/Apartment';
import DashboardIcon from '@mui/icons-material/Dashboard';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import fetch from '../../../Api/definitionCoursePage';

const routes = {
  0: '/definicion/empresa',
  1: '/definicion/seleccion/departamento',
  2: '/definicion/seleccion/puesto',
};

const initCards = [
  {
    title: 'Empresa',
    description: 'Cursos a aprobar por la empresa',
    Icon: ApartmentIcon,
    num: 0,
    primaryColor: '#844ec8',
    secondaryColor: '#ebe2f6',
  },
  {
    title: 'Departamento',
    description: 'Cursos a aprobar por departamento',
    Icon: DashboardIcon,
    num: 0,
    primaryColor: '#a7f200',
    secondaryColor: '#f1fdd6',
  },
  {
    title: 'Puesto',
    description: 'Cursos a aprobar por puestos',
    Icon: AssignmentIndIcon,
    num: 0,
    primaryColor: '#32bbff',
    secondaryColor: '#def4ff',
  },
];

const useInformation = () => {
  const history = useHistory();
  const [cards, setCards] = useState([]);

  useEffect(() => {
    let isMounted = true;

    if (isMounted) {
      fetch().then(data => {
        if (!data) {
          return;
        }

        initCards[0].num = data.countByEnterprise;
        initCards[1].num = data.countByDepartment;
        initCards[2].num = data.countByJobTitle;
        setCards(initCards);
      });
    }

    return () => {
      isMounted = false;
      setCards([]);
    };
  }, []);

  const handlePage = index => {
    history.push({
      pathname: routes[index],
      state: {
        isComingFrom: '/definicion',
      },
    });
  };
  return { cards, handlePage };
};

export default useInformation;
